import { ArrowUpRight } from "@phosphor-icons/react";
import { SERVICES } from "@/data/content";
import { motion } from "framer-motion";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#050505] py-24 md:py-32 px-6 md:px-12 lg:px-24"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16 md:mb-24">
        <div className="lg:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#E50914] mb-6">
            // 01 — What we do
          </p>
          <h2
            data-testid="services-title"
            className="font-display uppercase text-white text-5xl sm:text-6xl md:text-7xl leading-[0.9]"
          >
            Built for <br /> the rollout.
          </h2>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          <p className="text-zinc-300 text-lg md:text-xl leading-relaxed">
            Three disciplines, one studio. We approach every project with a
            creative edge — blending storytelling, lighting, and motion to
            deliver a polished, industry-level look for the artists who want
            more than content.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        {SERVICES.map((s, i) => {
          // Asymmetric bento layout for 4 cards:
          // i=0 big (col-7 row-2), i=1 (col-5), i=2 (col-5), i=3 full (col-12)
          const spanClass =
            i === 0
              ? "md:col-span-7 md:row-span-2"
              : i === 3
              ? "md:col-span-12"
              : "md:col-span-5";
          const imageHeight =
            i === 0 ? "h-72 md:h-96" : i === 3 ? "h-64 md:h-80" : "h-56 md:h-64";
          return (
            <motion.a
              href="#contact"
              key={s.id}
              data-testid={`service-card-${s.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative bg-[#0d0d0d] border border-white/10 hover:border-white/30 transition-colors duration-300 overflow-hidden ${spanClass}`}
            >
              <div className={`relative ${imageHeight} overflow-hidden`}>
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute top-4 left-4 font-mono text-xs uppercase tracking-[0.25em] text-white/70">
                  {s.number}
                </div>
                <div className="absolute top-4 right-4 w-10 h-10 bg-[#E50914] group-hover:bg-white flex items-center justify-center transition-colors duration-300">
                  <ArrowUpRight size={18} weight="bold" className="text-white group-hover:text-black" />
                </div>
              </div>

              <div className="p-6 md:p-8">
                <h3 className="font-display uppercase text-white text-3xl md:text-4xl leading-none mb-3">
                  {s.title}
                </h3>
                <p className="text-[#E50914] font-mono text-xs uppercase tracking-[0.25em] mb-5">
                  {s.tagline}
                </p>
                <p className="text-zinc-400 text-sm md:text-base leading-relaxed mb-6">
                  {s.description}
                </p>
                <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
                  {s.deliverables.map((d) => (
                    <li
                      key={d}
                      className="flex items-start gap-2 text-zinc-300 text-xs md:text-sm"
                    >
                      <span className="mt-1.5 w-1.5 h-1.5 bg-[#E50914] shrink-0" />
                      {d}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.a>
          );
        })}
      </div>
    </section>
  );
}
